<div class="mp-textarea {{size}} {{customClasses}}" [class.disabled]="disabled">
  <ng-container *ngIf="formControlField">
    <label *ngIf="formControlField.value"
           class="mp-textarea-label" for="mp-form-control-textarea">{{label | translate}}</label>
    <textarea id="mp-form-control-textarea"
           [readonly]="disabled"
           class="mp-textarea-field"
           [class.size-locked]="sizeLocked"
           [rows]="rows"
           [class.without-value]="!formControlField.value"
           placeholder="{{label | translate}}"
           [formControl]="formControlField"></textarea>
  </ng-container>
  <ng-container *ngIf="!formControlField">
    <label *ngIf="textareaValue"
           class="mp-textarea-label" for="mp-value-textarea">{{label | translate}}</label>
    <textarea id="mp-value-textarea"
           [readonly]="disabled"
           class="mp-textarea-field"
           [class.size-locked]="sizeLocked"
           [class.without-value]="!textareaValue"
           [rows]="rows"
           placeholder="{{label | translate}}"
           [(ngModel)]="textareaValue"
           (ngModelChange)="onValueChanged()"></textarea>
  </ng-container>
</div>



